import React from "react"
import styles from "./styles.scss"

class Screenshot extends React.Component {
  render() {
    return (
      <div className={styles.screenshotContainer}>
        <img
          className={styles.screenshot}
          src={this.props.image}
          alt={this.props.alt}
        />
      </div>
    )
  }
}

export default Screenshot



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MiasanoCaseStudy/Screenshot/index.jsx